import { WeaTools } from 'ecCom';

export const baseUrl = '/api/sensitive';

export const getSettingInfo = () => {
  return WeaTools.callApi(`${baseUrl}/settingInfo`, 'GET', {});
}

export const saveSettingInfo = params => {
  return WeaTools.callApi(`${baseUrl}/saveSettingInfo`, 'POST', params);
}

export const saveWord = params => {
  return WeaTools.callApi(`${baseUrl}/saveSensitiveWord`, 'POST', params);
}

export const deleteWord = params => {
  return WeaTools.callApi(`${baseUrl}/deleteSensitiveWord`, 'POST', params);
}

export const getWordInfo = params => {
  return WeaTools.callApi(`${baseUrl}/getSensitiveWord`, 'POST', params);
}

export const getWordListKey = params => {
  return WeaTools.callApi(`${baseUrl}/listSensitiveWord`, 'POST', params);
}

export const getWordLogKey = params => {
  return WeaTools.callApi(`${baseUrl}/listSensitiveLogs`, 'POST', params);
}

export const searchCondition = params => {
  return WeaTools.callApi(`${baseUrl}/searchCondition`, 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4backstage/smallApp/security/apis/wordset.js